import { Badge } from "@components/ui/badge";
import { Button } from "@components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@components/ui/dialog";
import { useState } from "react";
import { CricketTeamType } from "./index.column";

export default function PlayersCell({ row }: { row: CricketTeamType }) {
  const [open, setOpen] = useState(false);
  const visiblePlayers = row.players.slice(0, 3);
  const remainingCount = row.players.length - 3;

  return (
    <div className="flex items-center flex-wrap w-100">
      <div className="flex flex-wrap gap-2">
        {visiblePlayers.map((player) => (
          <Badge
            key={player.id}
            variant="outline"
            className="rounded-full px-3 py-1 font-normal"
          >
            {player.name}
          </Badge>
        ))}
      </div>

      {remainingCount > 0 && (
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Badge
              variant="warning"
              className="rounded-full px-3 py-1 font-normal cursor-pointer hover:bg-gray-200"
            >
              +{remainingCount} more
            </Badge>
          </DialogTrigger>
          <DialogContent className="sm:max-w-[425px]">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2 text-teal-700">
                <span
                  className={`fi fi-${row.iso_code?.toLowerCase()} text-2xl rounded-full`}
                />
                Players Name List
              </DialogTitle>
            </DialogHeader>
            <div className="max-h-[300px] overflow-y-auto py-4">
              <div className="flex flex-col gap-2">
                {row.players.map((player) => (
                  <div
                    key={player.id}
                    className="p-2 hover:bg-gray-50 rounded-md text-sm font-medium text-gray-700"
                  >
                    {player.name}
                  </div>
                ))}
              </div>
            </div>
            <DialogFooter className="sm:justify-start">
              <Button
                type="button"
                className="w-full bg-teal-600 hover:bg-teal-700 text-white"
                onClick={() => setOpen(false)}
              >
                Done
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
